import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

const Root = styled(Vertical).attrs({ gap: 2 })`
  justify-content: space-between;
  width: 100%;
`;
const IconWrapper = styled.span`
  min-width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  icon?: ReactNode;
  children: ReactNode;
};

export const Toggle = ({ icon, children }: Props) => {
  return (
    <Root>
      <Horizontal>
        {!!icon && <IconWrapper>{icon}</IconWrapper>}
        {children}
      </Horizontal>
    </Root>
  );
};
